/**
 * Pure parts of the rental's Přehled (today's board): the order and wording of its sections, and how late a car is.
 * The server classifies the reservations (`GET /v1/pujcovna/prehled`); this only lays them out.
 */

import type { MarkerTone } from '@/components/Marker';
import type { Prehled, Rezervace } from './api';

export type PrehledSekceId = 'po_terminu' | 'vraceni_dnes' | 'ceka_na_predani' | 'predani_dnes' | 'vraceni_brzy' | 'predani_brzy';

export interface PrehledSekce {
  id: PrehledSekceId;
  title: string;
  tone: MarkerTone;
  /** What a writer does with a row: hand the car over, or take it back. */
  akce: 'predat' | 'prijmout';
  rows: Rezervace[];
}

/** The sections in the order a day is worked: what is wrong first, then today, then the next 3 days. Empty ones are kept (the page decides). */
export function sekcePrehledu(p: Prehled): PrehledSekce[] {
  return [
    { id: 'po_terminu', title: 'Po termínu', tone: 'danger', akce: 'prijmout', rows: p.po_terminu },
    { id: 'ceka_na_predani', title: 'Čeká na předání', tone: 'warn', akce: 'predat', rows: p.ceka_na_predani },
    { id: 'vraceni_dnes', title: 'Dnes k vrácení', tone: 'accent', akce: 'prijmout', rows: p.vraceni_dnes },
    { id: 'predani_dnes', title: 'Dnes k předání', tone: 'accent', akce: 'predat', rows: p.predani_dnes },
    { id: 'vraceni_brzy', title: 'Příští 3 dny k vrácení', tone: 'neutral', akce: 'prijmout', rows: p.vraceni_brzy },
    { id: 'predani_brzy', title: 'Příští 3 dny k předání', tone: 'neutral', akce: 'predat', rows: p.predani_brzy },
  ];
}

/** Whole minutes from `od` to `do`, both Prague-local `YYYY-MM-DD HH:mm` (0 for a malformed one; never negative). */
export function minutMezi(od: string, doo: string): number {
  const a = Date.parse(`${od.replace(' ', 'T')}:00Z`);
  const b = Date.parse(`${doo.replace(' ', 'T')}:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b)) return 0;
  return Math.max(0, Math.round((b - a) / 60000));
}
